{
  "name": "insured-portal-ui",
  "version": "1.0.0",
  "private": true,
  "scripts": {
    "ng": "cross-env NODE_OPTIONS=--max_old_space_size=4096 ng",
    "build": "npm run ng build",
    "build-dev": "ng build --configuration=dev",
    "build-int": "ng build --configuration=int",
    "build-stage": "ng build --configuration=stage",
    "build-live": "ng build --configuration=production",
    "build-prod": "ng build --configuration=production",
    "start": "ng serve --proxy-config=proxy.conf.js --port=3333",
    "start-int": "npm start --configuration=int",
    "start-stage": "npm start --configuration=stage",
    "start-prod": "npm start --configuration=production",
    "serve:sw": "npm run build -s && npx http-server ./dist -p 5000",
    "lint": "npm run ng lint && stylelint \"src/**/*.scss\" --syntax scss && htmlhint \"src\" --config .htmlhintrc",
    "test": "npm run ng test",
    "test:ci": "npm run lint -s && npm run ng test --configuration=ci",
    "translations:extract": "ngx-translate-extract --input ./src --output ./src/translations/template.json --format=json --clean --sort --marker extract",
    "prettier": "prettier --write \"./{src,e2e}/**/*.{ts,js,html,scss}\"",
    "prettier:check": "prettier --list-different \"./{src,e2e}/**/*.{ts,js,html,scss}\"",
    "generate": "npm run ng generate"
  },
  "dependencies": {
    "@angular/animations": "20.3.31",
    "@angular/cdk": "20.2.14",
    "@angular/common": "20.3.31",
    "@angular/compiler": "20.3.31",
    "@angular/core": "20.3.31",
    "@angular/forms": "20.3.31",
    "@angular/localize": "20.3.31",
    "@angular/platform-browser": "20.3.31",
    "@angular/platform-browser-dynamic": "20.3.31",
    "@angular/router": "20.3.31",
    "@archinsurance-da/arch-portal-tools": "^20.0.0",
    "@auth0/angular-jwt": "^5.0.2",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-free": "^6.4.2",
    "@fortawesome/fontawesome-svg-core": "^6.4.2",
    "@fortawesome/free-brands-svg-icons": "^6.4.2",
    "@fortawesome/free-solid-svg-icons": "^6.4.2",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@ngbracket/ngx-layout": "^20.0.1",
    "@ngx-translate/core": "^15.0.0",
    "@types/jquery": "^3.3.37",
    "angular-oauth2-oidc": "^20.0.0",
    "bootstrap": "^4.6.0",
    "jquery": "^3.5.0",
    "ngx-bootstrap": "^20.0.2",
    "npm-font-open-sans": "^1.1.0",
    "object-mapper": "^6.2.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.6.2",
    "whatwg-fetch": "^3.5.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "20.3.37",
    "@angular/cli": "20.3.37",
    "@angular/compiler-cli": "20.3.31",
    "@angular/language-service": "20.3.31",
    "@angularclass/hmr": "3.0.0",
    "@biesbjerg/ngx-translate-extract": "7.0.4",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "3.7.7",
    "@types/jasminewd2": "2.0.9",
    "@types/node": "^22.0.0",
    "cross-env": "7.0.3",
    "htmlhint": "^1.1.4",
    "https-proxy-agent": "5.0.0",
    "husky": "4.3.8",
    "jasmine-core": "^3.8.0",
    "jasmine-spec-reporter": "6.0.0",
    "jwt-decode": "^4.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "3.1.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "4.0.1",
    "karma-jasmine-html-reporter": "1.6.0",
    "karma-junit-reporter": "2.0.1",
    "launchdarkly-js-client-sdk": "^3.9.0",
    "prettier": "2.3.1",
    "pretty-quick": "3.1.0",
    "stylelint": "17.14.0",
    "stylelint-config-prettier": "8.0.2",
    "stylelint-config-recommended-scss": "17.0.1",
    "stylelint-config-standard": "20.0.0",
    "stylelint-scss": "7.2.0",
    "ts-node": "9.1.1",
    "tslint": "6.1.3",
    "tslint-config-prettier": "1.18.0",
    "typescript": "5.8.3"
  },
  "resolutions": {
    "prosemirror-commands": "~1.2.1",
    "prosemirror-keymap": "~1.1.5",
    "prosemirror-model": "~1.16.1",
    "prosemirror-schema-list": "~1.1.6",
    "prosemirror-state": "~1.3.4",
    "prosemirror-transform": "~1.3.3",
    "prosemirror-view": "~1.23.6",
    "@types/prosemirror-commands": "~1.0.4",
    "@types/prosemirror-keymap": "~1.0.4",
    "@types/prosemirror-model": "~1.16.0",
    "@types/prosemirror-schema-list": "~1.0.3",
    "@types/prosemirror-state": "~1.2.8",
    "@types/prosemirror-transform": "~1.1.5",
    "@types/prosemirror-view": "~1.23.1"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "*"
  },
  "overrides": {
    "browserslist": "4.29.0",
    "ws": "8.21.0",
    "minimatch": "3.1.4",
    "flatted": "3.4.2",
    "@phenomnomnominal/tsquery": "6.2.0",
    "ajv": "8.18.0",
    "fast-uri": "4.1.3",
    "hono": "4.13.5",
    "lodash": "4.18.1",
    "path-to-regexp": "8.4.2",
    "picomatch": "4.0.5",
    "socket.io": "4.8.3",
    "socket.io-parser": "4.2.7",
    "tmp": "0.2.7"
  },
  "prettier": {
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.scss",
        "options": {
          "singleQuote": false
        }
      }
    ]
  },
  "husky": {
    "hooks": {
      "pre-commit": "pretty-quick --staged"
    }
  }
}
